import { render, staticRenderFns } from "./OrderProcesses.vue?vue&type=template&id=356c4b2e"
import script from "./OrderProcesses.vue?vue&type=script&lang=js"
export * from "./OrderProcesses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports